export const capitalizeEachWord = (str?: string) => {
	if (!str) return '';
	return str.replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase());
};
